import { Icon, Text, HStack, VStack } from '@genial/components';
import React from 'react';

interface CustomerDuckWarningProps {
  message: string;
}

export const CustomerDuckWarning: React.FC<CustomerDuckWarningProps> = ({ message }) => {
  return (
    <HStack space="inset.nano" alignItems="center">
      <Icon name="Warning" size="xxs" color="feedback.attention.default" />
      <Text>{message}</Text>
    </HStack>
  );
};

export const CustomerDuckWarningLoading: React.FC = () => {
  return (
    <HStack space="inset.nano" alignItems="center">
      <Icon name="Warning" size="xxs" color="feedback.attention.default" />
      <VStack space="stack.quarck" flex={1}>
        <Text flex={1} maxW="4/5" isLoading />
        <Text flex={1} maxW="3/5" isLoading />
      </VStack>
    </HStack>
  );
};
